module.exports = __webpack_public_path__ + "img/Afisul_Proiectului_A3.a57f1951.png";